import { z } from 'zod/v4';

const CompanyRefSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const OrderListEntrySchema = z.object({
  id: z.string(),
  orderNumber: z.string(),
  orderType: z.enum(['PURCHASE_ORDER', 'SALES_ORDER']),
  buyer: CompanyRefSchema,
  supplier: CompanyRefSchema,
});

const DocumentTypeExpandedSchema = z.object({
  id: z.string().nullable(),
  title: z.string(),
  documentClass: z.enum(['TRANSACTIONAL', 'COMPANY']).nullable(),
  isDeprecated: z.boolean(),
  impactAreaId: z.string().nullable(),
});

export const StyleOrderDocumentSchema = z.object({
  fileId: z.string(),
  documentId: z.string().nullable(),
  name: z.string(),
  fileUrl: z.string().nullable(),
  documentTypeId: z.string().nullable(),
  documentType: DocumentTypeExpandedSchema.nullable(),
  createdAt: z.coerce.date().nullable(),
  updatedAt: z.coerce.date().nullable(),
  isArchived: z.boolean(),
  orderList: z.array(OrderListEntrySchema),
});

export type StyleOrderDocumentType = z.infer<typeof StyleOrderDocumentSchema>;
